<template>
    <v-row  style="display: flex; height: 100%; width: 100%; align-items: center" class="ma-0" id="navbar-top">
        <div v-if="$store.getters.accountTypeId !== 4" style="flex: 1; display: flex; align-items: center;" class="ml-4">
            <div style="width: 80%">
                <app-test-search-two class="ml-2"></app-test-search-two>
            </div>
        </div>
        <div v-else style="flex: 1">

        </div>
	    <div>
		    <v-tooltip location="bottom">
			    <template v-slot:activator="{ props }">
				    <a
					    href="https://university.swaymedical.com/"
					    target="_blank"
					    v-bind="props"
				    >
					    <img :src="swayULogo" alt="" style="height: 30px">
				    </a>
			    </template>
			    <span>
				    Sway University
			    </span>
		    </v-tooltip>


	    </div>
	    <div style="height: 100%;" class="pa-3">
		    <v-divider vertical></v-divider>
	    </div>
	    
        <div>
            <v-menu
                location="bottom"
                open-on-hover
				style="overflow: hidden"
            >
                <template v-slot:activator="{ props }">
                    <div v-bind="props">
                        <div style="display: flex; flex-direction: row; align-items: center" class="mr-10">

                            <!--                            <div class="mr-3">-->
                            <!--                                <v-avatar-->
                            <!--                                    color="light"-->
                            <!--                                    size="48"-->
                            <!--                                >-->
                            <!--                                    <span>-->
                            <!--                                      <v-icon class="icon" size="36" color="dark">{{ icon }}</v-icon>-->
                            <!--                                    </span>-->
                            <!--                                </v-avatar>-->
                            <!--                            </div>-->
                            <div style="display: flex; flex-direction: column;">
                                <h3>
                                    {{ firstName }}
                                </h3>
                                <div style="color: var(--v-text-lighten2); font-size: 13px">
                                    {{ organizationNameToDisplay }}
                                </div>
                            </div>


                            <div class=" ml-2">
                                <v-icon class="account-dropdown-arrow" color="dark">mdi-chevron-down</v-icon>
                            </div>
                        </div>
                    </div>
                </template>

                <app-card style="overflow: scroll; max-height:600px"
                    class="mx-auto"
                    :min-width="300"
                    hide-header
                >
                    <div class="pa-3" style="display: flex; align-items: center">
                        <div >
                            <v-icon :size="40">mdi-account-circle-outline</v-icon>
                        </div>
                        <div  class="ml-4">

                            <div style="display: flex; flex-direction: row" >
                                <div style="flex: 1; font-size: 16px; font-weight: 500">{{ firstName }} {{ lastName }}</div>
                            </div>
                            <div v-if="allowEditAccount" style="font-size: 13px; color: #0070c9; font-weight: 400" class="custom-text-link" @click="$router.push(`/account/personal-information`)">Edit Account</div>
                        </div>
                    </div>

                    <v-divider ></v-divider>
                    <div v-if="$store.getters.availableOrganizations">
                        <v-list density="compact">
                            <v-list-item
                                v-for="(item, i) in $store.getters.availableOrganizations"
                                :key="i"
                                @click="changeOrganization(item)"
                                class="account-dropdown-list-item"
                            >
                                <div style="display: flex; align-items: center">
                                    <div style="width: 30px">
                                        <v-icon v-if="item.id === $store.getters.currentOrganizationId" :size="14">mdi-check-bold</v-icon>
                                    </div>
                                    <div style="font-size: 14px">
                                        {{item.name}} {{isSuperAdmin ? `(${item.id})` : ''}}
                                    </div>
                                    <span v-if="item.isEnterpriseAdminOrg" class="ml-2">
                                        <app-chip label color="blue" small class="ma-1">Enterprise</app-chip>
                                    </span>
                                </div>
                            </v-list-item>
                        </v-list>
                        <v-divider></v-divider>
                    </div>

                    <v-list density="compact">
                        <v-list-item
                            v-for="(item, i) in items"
                            :key="i"
                            @click="item.onClick()"
                            class="account-dropdown-list-item"
                        >
                            <div >
                                <div class="list-item-text" style="font-size: 14px; margin-left: 30px">
                                    {{item.text}}
                                </div>
                            </div>
                        </v-list-item>
                    </v-list>
                </app-card>

            </v-menu>

        </div>
    </v-row>
</template>

<script>


import AppTestSearchTwo from "@/components/AppTestSearch2";
import {mdiAccountOutline} from "@mdi/js";
import {logout, switchSelectedOrganization} from "@/services/userService";
import {masterSearch} from "@/services/organization.service";
import {SET_IS_SWITCHING_ORG} from "@/store/mutation-types";
import swayULogo from '@/assets/svgs/sway-univeristy-logo.svg'


export default {
    name: "NavbarTop",
    components: {
        AppTestSearchTwo
    },
    data() {
        return {
            icon: mdiAccountOutline,
            selectedItem: 1,
            search: '',
            select: null,
            searchItems: [],
	        swayULogo
        }
    },
    watch: {
        search(val) {
            val && val !== this.select && this.performMasterSearch(val)
        },
    },
    mounted() {
        if (this.$store.getters.accountTypeId !== 4) {
            this.performMasterSearch('')
        }

    },
    computed: {
        searchPlaceholder() {
            return !this.searchField && 'Search'
        },
        firstName() {
            return this.$store.getters.firstName;
        },
        lastName() {
            return this.$store.getters.lastName;
        },
        organization() {
            return this.$store.state.currentOrganization.name
        },
        allowEditAccount() {
            return !this.$store.getters.viewingAsSuper
        },
        viewingAsSuper() {
            return this.$store.getters.viewingAsSuper
        },
        isSuperAdmin() {
            return this.$store.getters.isSuperAdmin
        },
        organizationNameToDisplay() {
            let name = this.$store.getters.selectedOrganizationName;
            if (!name) {
                return "LOADING..."
            } else if (name < 30) {
                return name;
            } else {
                return name.slice(0,30) + '...';
            }
        },
        items() {
            let items = []

            // if (this.allowEditAccount) {
            //     items.push({text: 'My Account', icon: 'mdi-clock', onClick: () => this.$router.push('/account/personal-information')})
            // }

            // items.push({text: 'Organization', icon: 'mdi-clock', onClick: () => this.$router.push('/organization')})
            items.push({text: 'Sign Out', icon: 'mdi-flag', onClick: this.logout},)
            return items
        }
    },
    methods: {
        logout() {
            //set currentAccount to null
            this.$store.state.currentAccount = null;
            logout(() => this.$router.push('/login'))
        },
        async changeOrganization(organization) {
            // Show a loader during the switch so the user doesn't see a hybrid layout
            // (new org's chrome around the old org's route content).
            this.$store.commit(SET_IS_SWITCHING_ORG, true);
            try {
                await switchSelectedOrganization(organization.id);
                await this.$router.push(`/dashboard?orgId=${organization.id}`);
            } finally {
                this.$store.commit(SET_IS_SWITCHING_ORG, false);
            }
        },
        async performMasterSearch() {
            const data = await masterSearch(this.search)

            if (!data.searchResults) return null

            // type 1 = Profile
            // type 2 = Group
            // type 3 = Protocol
            // type 4 = Account

            let profiles = [];
            let groups = [];
            let protocols = [];
            let accounts = [];

            data.searchResults.forEach(result => {
                switch (result.type) {
                    case 1:
                        profiles.push(result);
                        break;
                    case 2:
                        groups.push(result);
                        break;
                    case 3:
                        protocols.push(result);
                        break;
                    case 4:
                        accounts.push(result)
                }
            })

            let final = [];
            if (profiles.length > 0) {
                final.push({header: 'Profiles'})
                profiles.forEach(profile => {
                    final.push({
                        name: profile.title,
                        id: profile.id
                    })
                })
            }
            if (groups.length > 0) {
                final.push({header: 'Groups'})
                groups.forEach(group => {
                    final.push({
                        name: group.title,
                        id: group.id
                    })
                })
            }
            if (protocols.length > 0) {
                final.push({header: 'Protocols'})
                protocols.forEach(protocol => {
                    final.push({
                        name: protocol.title,
                        id: protocol.id
                    })
                })
            }
            if (accounts.length > 0) {
                final.push({header: 'Accounts'})
                accounts.forEach(account => {
                    final.push({
                        name: account.title,
                        id: account.id
                    })
                })
            }


            this.itemsForDropdown = final
        }
    },
}
</script>

<style scoped lang="scss">

#navbar-top {
    background-color: white;
    border-bottom: 1px solid #E5E7EB;
}

.v-autocomplete__content {
    border-radius: 12px !important;
}

.v-text-field .v-input__control .v-input__slot {
    max-height: 30px !important;
    display: flex !important;
    align-items: center !important;
}

.icon {
    fill: currentColor;
}

.account-dropdown-arrow-container {
    height: 25px;
    width: 25px;
    background-color: #F3F4F6;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
}

.account-dropdown-arrow {
    color: #6B7280;
}

.search-input-area {
    border-radius: 12px;
}

.v-text-field--outlined {
    border: none !important;
}

.list-item-text {
    color: #1F2937;
    font-family: 'Inter', sans-serif;
}

.account-dropdown-list-item:hover {
    background-color: #F3F4F6;
}

.account-dropdown-list-item {
    color: #1F2937 !important;
    border-radius: 8px;
    margin: 2px 8px;
    font-family: 'Inter', sans-serif;
}

.custom-text-link {
    color: #33D3FF !important;
    font-weight: 500;
    cursor: pointer;
    transition: color 0.15s ease;
}

.custom-text-link:hover {
    color: #00B8E6 !important;
}

div[role=listbox] {
}

.route {
    text-decoration: none;
}

h3 {
    font-family: 'Inter', sans-serif;
    font-weight: 600;
    color: #1F2937;
}
</style>